import { ProductsContainerMode } from "@holibob-packages/ui-core/product";

import { useEntityConfigurationValueByKey } from "./useEntityConfiguration";

export function useCurationProductsListViewMode(): ProductsContainerMode {
    const isGrid = useEntityConfigurationValueByKey<boolean>("SETTING.CURATION_GRID") ?? false;
    return isGrid ? "grid" : "slider";
}
